import { alpha, Box, useTheme } from "@mui/material";
import type { FC, RefObject } from "react";
import { useDashboardStatusBarColor } from "web_myplann/Dashboard/Hooks/useDashboardStatusBarColor";
import type { DashboardType } from "web_myplann/Dashboard/Types/DashboardType";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";
import { useScrolledPastTop } from "web_myplann/Shared/Hooks/useScrolledPastTop";

type Props = {
	heroRef: RefObject<HTMLElement | null>;
	dashboard: DashboardType;
};

export const DashboardDetailStickyHeader: FC<Props> = ({
	heroRef,
	dashboard,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const scrolledPast = useScrolledPastTop(heroRef, {
		root: null,
		topOffsetPx: theme.navigation.header.height,
	});

	useDashboardStatusBarColor(scrolledPast ? undefined : dashboard.gradientFrom);

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			right={0}
			zIndex={theme.zIndex.appBar}
			bgcolor={scrolledPast ? theme.palette.background.paper : "transparent"}
			sx={{ transition: "background-color 0.2s" }}
		>
			<MyPlannNavigationHeader
				title={scrolledPast ? dashboard.type : ""}
				defaultRoute={Routing.Dashboard.path()}
				alwaysUseDefaultRoute
				backLabel={t(Resources.Dashboard.Detail.back)}
				bgColor="transparent"
				iconColor={
					scrolledPast
						? theme.palette.grey[900]
						: alpha(theme.palette.darkmodeText.white, 0.9)
				}
			/>
		</Box>
	);
};
